import config from "./config";

config.debug = true

export default config
